import type { Campaign } from './model';

/** The pause exception only opens a listed task for its owner or an admin. */
export function isTaskPagePaused(
  campaign: Pick<Campaign, 'id' | 'paused' | 'pauseAllowedTaskIds'> | null,
  task: { id: string; campaignId?: string | null; ownerId: string | null } | null,
  userId: string | null | undefined,
  isAdmin: boolean,
): boolean {
  if (!campaign?.paused) return false;
  return !(task && task.campaignId === campaign.id
    && campaign.pauseAllowedTaskIds?.includes(task.id)
    && userId && (isAdmin || task.ownerId === userId));
}
